import * as React from "react";

import {
	createNativeStackNavigator,
	NativeStackScreenProps,
} from "@react-navigation/native-stack";

import ServicesHub from "./ServicesHub";
import ServicesHubHeader from "./ServicesHubHeader";
import Discounts from "./Discounts";
import DiscountsHeader from "./DiscountsHeader";
import DiscountBanner from "../../../components/DiscountBanner";
export type ServicesStackNavParamList = {
	ServicesHub: undefined;
	Discounts: undefined;
	SpecificDiscount: undefined;
};
const ServicesStackNav =
	createNativeStackNavigator<ServicesStackNavParamList>();

export type ServicesStackProps = NativeStackScreenProps<
	ServicesStackNavParamList,
	"ServicesHub",
	"Discounts"
>;
// export type SpecificCategoryScreenProps = NativeStackScreenProps<
// 	DiscountStackNavParamList,
// 	"Specific"
// >;
const ServicesStack = () => {
	return (
		<ServicesStackNav.Navigator
			initialRouteName="ServicesHub"
			screenOptions={{
				header: props => {
					if (props.navigation.getState().index === 0)
						return <ServicesHubHeader />;
					if (props.navigation.getState().index === 1)
						return <DiscountsHeader />;
					return null;
				},
			}}
		>
			<ServicesStackNav.Screen name="ServicesHub" component={ServicesHub} />
			<ServicesStackNav.Screen name="Discounts" component={Discounts} />
			<ServicesStackNav.Screen
				name="SpecificDiscount"
				component={DiscountBanner}
				options={{ headerShown: false }}
			/>
			{/* <DiscountStackNav.Screen name="Specific" component={SpecificCategory} /> */}
		</ServicesStackNav.Navigator>
	);
};

export default ServicesStack;
